import { render, staticRenderFns } from "./confirmDeleteSMSTemplate.vue?vue&type=template&id=15512154&scoped=true"
import script from "./confirmDeleteSMSTemplate.vue?vue&type=script&lang=js"
export * from "./confirmDeleteSMSTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15512154",
  null
  
)

export default component.exports